















import Component, { mixins } from 'vue-class-component';

import FormBase from '@/general/abstract/form/FormBase.vue';
import { VModel } from 'vue-property-decorator';
import WorkPeriodTemplateFormTemplate
  from '@/context/work_period/component/template-form/WorkPeriodTemplateFormTemplate.vue';
import { WorkPeriodTemplate } from '@/context/work_period/model/WorkPeriodTemplate';
import SimpleForm from '@/general/abstract/form/mixin/SimpleForm';
import { WorkPeriodApi } from '@/context/work_period/api/WorkPeriodApi';
import WorkPeriodRouter from '@/context/work_period/router/WorkPeriodTemplateRouter';

@Component({
  components: {
    WorkPeriodTemplateFormTemplate,
    FormBase
  }
})
export default class WorkPeriodTemplateForm extends mixins<SimpleForm<WorkPeriodTemplate>>(
  SimpleForm
) {
  @VModel({ default: new WorkPeriodTemplate() }) model!: WorkPeriodTemplate;

  buildCmd(): WorkPeriodTemplate {
    if (this?.model?.id) {
      return this.model;
    }
    let command: WorkPeriodTemplate = Object.assign<WorkPeriodTemplate, WorkPeriodTemplate>(
      new WorkPeriodTemplate(),
      this.model
    );
    return command;
  }

  async submitApi(cmd: WorkPeriodTemplate): Promise<WorkPeriodTemplate> {
    const model: WorkPeriodTemplate = cmd.id
      ? await WorkPeriodApi.instance().update<WorkPeriodTemplate, WorkPeriodTemplate>(cmd)
      : await WorkPeriodApi.instance().create<WorkPeriodTemplate, WorkPeriodTemplate>(cmd);
    return model;
  }

  showRoute(id: number): Record<string, unknown> {
    return WorkPeriodRouter.instance().list();
  }
}
